module.exports = __webpack_public_path__ + "assets/img/user-icon_wc.4de42c82.svg";